import { useEffect, useState } from "react";

export type Theme = "dark" | "light";

const STORAGE_KEY = "nt_theme";

function resolveInitialTheme(): Theme {
  if (typeof window === "undefined") return "dark";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === "dark" || stored === "light") return stored;
  return "dark"; // dark is the design's canonical mode
}

export interface ThemeBinding {
  theme: Theme;
  isDark: boolean;
  setTheme: (next: Theme) => void;
  toggle: () => void;
}

export function useTheme(): ThemeBinding {
  const [theme, setThemeState] = useState<Theme>(resolveInitialTheme);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, theme);
    }
    if (typeof document !== "undefined") {
      document.documentElement.setAttribute("data-theme", theme);
    }
  }, [theme]);

  return {
    theme,
    isDark: theme === "dark",
    setTheme: setThemeState,
    toggle: () => setThemeState((p) => (p === "dark" ? "light" : "dark")),
  };
}
